import {
  useCallback, useEffect,
} from 'react';
import { useStorageService } from '~/_shared/utils/storageService';
import { ModalType } from '~/modal/modalType.enum';
import { useModal } from '~/modal/useModal.hook';
import { useUserDataUsagesSelector } from '~/store/userData/userData.selectors';

const seenWalkthroughKey = 'seenWalkthrough';

export const useEnsureWalkthroughModalFlag = () => {
  const mapCount = useUserDataUsagesSelector().createdMaps;
  const storageService = useStorageService();

  const hasSeenWalkthrough = !!storageService.getLocalStorageItem(seenWalkthroughKey);

  useEffect(() => {
    if (mapCount && !hasSeenWalkthrough) {
    // This sets the flag for users who already have maps but may remove them.
      storageService.setLocalStorageItem(seenWalkthroughKey, new Date().toISOString());
    }
  }, [hasSeenWalkthrough, mapCount, storageService]);
};

export const useShowWalkthroughModal = () => {
  const mapCount = useUserDataUsagesSelector().createdMaps;
  const storageService = useStorageService();
  const { openModal } = useModal(ModalType.Walkthrough);

  const hasSeenWalkthrough = !!storageService.getLocalStorageItem(seenWalkthroughKey);

  const showWalkthroughModal = useCallback(() => {
    if ((mapCount === 0) && !hasSeenWalkthrough) {
      openModal();
      storageService.setLocalStorageItem(seenWalkthroughKey, new Date().toISOString());
    }
  }, [hasSeenWalkthrough, mapCount, openModal, storageService]);

  return { showWalkthroughModal };
};
